// INPUT PLACEHOLDERS
export const PlaceholderMail = 'Enter your email'
export const PlaceholderPass = 'Enter your password'

// TEXT PLACEHOLDERS
// ------- confirmations ------- //
export const TxtConfirmCloseIssue = 'Are you sure you want to close this issue?'
export const TxtConfirmDeleteDept = 'Delete this department?'
export const TxtConfirmDeleteCompany = 'Delete this company?'
export const TxtConfirmDeleteContractor = 'Delete this contractor?'
export const TxtConfirmDeleteUser = 'Delete this user?'
export const TxtConfirmDeleteReport = 'Delete this report?'
export const TxtConfirmRenameDept = 'Do you want to accept this change?'
export const TxtConfirmRenameContractor = 'Do you want to accept this change?'
export const TxtConfirmDeleteDailyReport = 'Are you sure you want to delete this report?'
export const TxtConfirmBlastReport = 'Are you sure you want to blast selected report?'

// ------- success ------- //
export const TxtSuccessDeleteDept = 'Successfully deleted department.'
export const TxtSuccessDeleteCompany = 'Successfully deleted company.'
export const TxtSuccessDeleteContractor = 'Successfully deleted contractor.'
export const TxtSuccessDeleteUser = 'Successfully deleted user.'
export const TxtSuccessSubmit = 'Successfully submitted.'
export const TxtSuccessSubmitUser = 'Successfully submitted user.'
export const TxtSuccessSubmitCompany = 'Successfully submitted company.'
export const TxtSuccessSubmitContractor = 'Successfully submitted contractor.'
export const TxtSuccessSubmitGroup = 'Successfully submitted group.'
export const TxtSuccessSubmitTask = 'Successfully submitted task.'
export const TxtSuccessValidated = 'Successfully validated.'
export const TxtSuccessDeleteReport = 'Successfully deleted report.'
export const TxtSuccessDeleteBulk = "Successfully deleted bulk data.";
export const TxtSuccessDeleteDailyReport = 'You have successfully deleted this report'
export const TxtSuccessBlastReport = 'You have successfully blasted selected report'
export const TxtSuccessAddBlastReport = 'You have successfully submitted new blasting report'
export const TxtSuccessEditBlastReport = 'You have successfully edited blasting report'
export const TxtSuccessSendBackBlastReport = 'You have successfully sent back this blasting report'
export const TxtSuccessApproveBlastReport = 'You have successfully approved this blasting report'

// ------- failures ------- //
export const TxtFailedDelete = 'Failed to delete.'
export const TxtFailedDeleteDept = 'Failed to delete.'
export const TxtFailedDeleteContractor = 'Failed to delete.'
export const TxtFailedUpdate = 'Failed to update.'
export const TxtFailedSubmitData = 'Failed to submit. Please check all fields and/or connection.'
export const TxtFailedValidated = 'Failed to validated.'
export const TxtFailureGeneric = 'Oops, something wrong happened.'
export const TxtFailedDeleteBulk = "Failed to delete bulk.";
